import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { WorkflowStepType } from '@warema/shared/models';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import * as WorkflowActions from '../state/workflow.actions';
import { WorkflowState } from '../state/workflow.reducers';

@Injectable({
    providedIn: 'root',
})
export class WorkflowValidationService {
    private readonly _store = inject<Store<WorkflowState>>(Store);

    public manageWorkflowValidation(isFormValid$: Observable<boolean>, stepType: WorkflowStepType): void {
        isFormValid$.pipe(distinctUntilChanged()).subscribe(isValid => {
            this._store.dispatch(WorkflowActions.SetStepValidity({ isValid, stepType }));
        });
    }
}
